// removed by extract-text-webpack-plugin
module.exports = {"Scalar":"_1yBQv","Value":"_4U6UK","Title":"_1QEEv","small":"_3eqn_","large":"_2Rovb"};


//////////////////
// WEBPACK FOOTER
// ./visualizations/visualizations/Scalar.css
// module id = 434
// module chunks = 3 4 5